<bazis-grid class="bazis-grid_form">
    <bazis-row>
        <bazis-col
            sizeSm="6"
            sizeXs="12"
        >
            <bazis-input-date
                [formControl]="date"
                [titleKey]="dateTitleKey"
                [tooltipKey]="dateTooltipKey"
                [tooltipSettings]="tooltipDateSettings"
                [noteKey]="dateNoteKey"
                [required$]="required$"
                [maxDate]="maxDate"
                [inputFormat]="dateInputFormat"
                [minDate]="minDate"
                [placeholder]="datePlaceholder"
                [validationErrorMessages]="validationErrorMessages"
                [marks$]="marks$"
                [placeIcon]="placeIcon"
                precision="days"
                [sizeControl]="sizeControl"
                (touched)="markAsTouched()"
            ></bazis-input-date>
        </bazis-col>
        <bazis-col
            sizeSm="6"
            sizeXs="12"
        >
            <bazis-input-timeinterval
                [titleKey]="timeTitleKey"
                [tooltipKey]="timeTooltipKey"
                [tooltipSettings]="tooltipTimeSettings"
                [noteKey]="timeNoteKey"
                [required$]="required$"
                [placeholder]="timePlaceholder"
                (touched)="markAsTouched()"
                [inputFormat]="timeInputFormat"
                [formControl]="timeInterval"
                [validationErrorMessages]="validationErrorMessages"
                [sizeControl]="sizeControl"
            ></bazis-input-timeinterval>
        </bazis-col>
    </bazis-row>
    <bazis-row *ngIf="tooltipKey || noteKey">
        <bazis-col>
            <div>{{ tooltipKey }}</div>
            <div>{{ noteKey }}</div>
        </bazis-col>
    </bazis-row>
</bazis-grid>
